import { getStore as getListViewStore, type TableQueryType } from 'owa-mail-list-store';
import type { SearchTableQuery } from 'owa-mail-list-search';
import type { PeopleSuggestion } from 'owa-search-service/lib/data/schema/SuggestionSet';
import { SuggestionKind } from 'owa-search-service/lib/data/schema/SuggestionSet';

export function getPersonaSuggestionPillHeaderData(
    tableViewId: string | undefined
): PeopleSuggestion[] | null {
    const tableView = tableViewId && getListViewStore().tableViews.get(tableViewId);
    if (tableView) {
        if (tableView.tableQuery.type != 1) {
            throw new Error(
                'getPersonaSuggestionPillHeaderData should not be called for non-search scenario'
            );
        }

        const searchTableQuery = tableView.tableQuery as SearchTableQuery;
        const personaSuggestions = searchTableQuery.pillSuggestions.filter(suggestion => {
            return suggestion.kind == SuggestionKind.People;
        });

        // Fow now, we only handle the case where all search suggestion pills are of type persona.
        if (searchTableQuery.pillSuggestions.length === personaSuggestions.length) {
            return personaSuggestions as PeopleSuggestion[];
        }
    }

    return null;
}
